module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "level1 hidden",
    attrs: {
      "data-number": "1",
      "epub:type": "notice",
      "id": "disclaimer"
    }
  }, [_c('h1', {
    staticClass: "hidden",
    attrs: {
      "data-number": "1",
      "epub:type": "notice"
    }
  }, [_vm._v("Disclaimer")]), _vm._v(" "), _c('p', {
    staticClass: "no_header"
  }, [_vm._v("Except where actual historical events and characters are being described for the storyline of this novel, all situations in this publication are fictitious and any resemblance to living persons is purely coincidental.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0